import Card from '@material-ui/core/Card';
import { withStyles } from '@material-ui/core/styles';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { getColorFromThemeName } from '../../_config/utils';
import { GREEN, VIRTUAL_INTERCOM_EXTENSION_VISIBILITY } from '../../_config/consts';
import Tag from '../Tag.jsx';
import VisibilityVisibleIconCustom from '../CustomIcons/VisibilityVisibleIconCustom.jsx';
import VisibilityInvisibleIconCustom from '../CustomIcons/VisibilityInvisibleIconCustom.jsx';

const styles = {
  container: {
    marginBottom: 10,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    },
  },
  selected: {
    border: '2px solid',
  },
  content: {
    padding: 15,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    margin: 0,
  },
  id: {
    fontSize: 14,
    color: '#666',
    margin: 0,
  },
  section: {
    marginTop: 15,
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  usersContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '5px',
    marginTop: 5,
  },
  groupTag: {
    backgroundColor: '#e0e0e0',
    padding: '4px 8px',
    borderRadius: '0px',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  visibilityContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 5,
  },
};

class ExtensionRow extends React.Component {
  render() {
    const { classes, extension, isSelected, onClick, themeColor } = this.props;
    const color = getColorFromThemeName(themeColor);

    return (
      <Card 
        className={classes.container} 
        style={isSelected ? { ...styles.selected, borderColor: color } : {}}
        onClick={onClick}
      >
        <div className={classes.content}>
          <div className={classes.header}>
            <h3 className={classes.title}>{extension.name}</h3>
            <h4 className={classes.id}><Entity entity="extensionId" /> {extension.id}</h4>
          </div>

          <div className={classes.section}>
            <div>
              <div className="resourceInfoRow-typeTag-flat">
                <h5 style={{ color: 'white', margin: 0 }}>{extension.group?.name}</h5>
              </div>
            </div>
          </div>

          <div className={classes.section}>
            <h5 className={classes.sectionTitle}><Entity entity="extensionVisibility" /></h5>
            <div className={classes.visibilityContainer}>
              <h5 style={{ color: extension.visibility === VIRTUAL_INTERCOM_EXTENSION_VISIBILITY.VISIBLE ? GREEN : 'grey', marginRight: 10 }}>
                <Entity key={extension.visibility} entity={extension.visibility === VIRTUAL_INTERCOM_EXTENSION_VISIBILITY.VISIBLE ? 'extensionVisibilityVisible' : 'extensionVisibilityHidden'} />
              </h5>
              {extension.visibility === VIRTUAL_INTERCOM_EXTENSION_VISIBILITY.VISIBLE ? (
                <VisibilityVisibleIconCustom style={{ width: 20, color: GREEN }} />
              ) : <VisibilityInvisibleIconCustom style={{ width: 20, color: 'grey' }} />}
            </div>
          </div>

          <div className={classes.section}>
            <h5 className={classes.sectionTitle}><Entity entity="extensionUsers" /></h5>
            <div className={classes.usersContainer}>
              {_.map(_.sortBy(extension.users, 'id'), user => (
                <Tag
                  key={user.id}
                  tag={{type:'user', name: `${user.username}`, color: '#ba68c8'}}
                />
              ))}
            </div>
          </div>
        </div>
      </Card>
    );
  }
}

export default withStyles(styles)(ExtensionRow); 